export default __webpack_public_path__ + "static/media/avatar_tommy6.22a27f89.mp3";